module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('div', {
    staticClass: "flex flex-row items-center responsive-title pl2 pr2 pb2",
    on: {
      "click": _vm.goBack
    }
  }, [_c('arrow-back1'), _vm._v(" "), _c('h3', {
    staticClass: "ml3 f4 cera-round-pro"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('billingsettings.billingsettingsheader', {
    billingsettingsheader: 'Billing'
  })))])], 1), _vm._v(" "), _c('div', {
    staticClass: "inter container"
  }, [_c('div', {
    staticClass: "cell-multiple pv2 ph3 mv2 mh0 flex flex-column justify-center"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('span', {
    staticClass: "silver-element"
  }, [_vm._v(_vm._s(_vm.$t('billingsettings.nextpayment', {
    nextpayment: 'Next Payment'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between items-center",
    staticStyle: {
      "margin-top": ".75rem"
    }
  }, [_c('label', {
    staticClass: "f5 fw5 db"
  }, [_vm._v(_vm._s(_vm.nextInvoiceDate))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.nextInvoiceAmount))])])]), _vm._v(" "), _c('div', {
    staticClass: "silver-element pl3 mt3"
  }, [_vm._v(_vm._s(_vm.membershipStatus))]), _vm._v(" "), _c('div', {
    staticClass: "ph3 mt4 pay-now-responsive",
    staticStyle: {
      "overflow": "auto"
    }
  }, [(_vm.user.invoice_information.invoice_url && _vm.user.primary_account_holder.id == _vm.user.user_id) ? _c('a', {
    staticClass: "no-underline pay-btn dib-ns",
    attrs: {
      "href": _vm.user.invoice_information.invoice_url
    }
  }, [_c('ak-button', {
    staticClass: "pay-btn inter",
    attrs: {
      "disabled": !this.user.is_activated,
      "primary": ""
    }
  }, [_vm._v("Pay Now")])], 1) : _vm._e(), _vm._v(" "), _c('ak-button', {
    staticClass: "ph3 flex hide-drop",
    class: (_vm.showPreviousPayments) ? 'pad-payments-list' : '',
    nativeOn: {
      "click": function($event) {
        _vm.showPreviousPayments = !_vm.showPreviousPayments
      }
    }
  }, [_c('span', {
    staticClass: "color-theme inter",
    class: (_vm.showPreviousPayments) ? 'pad-payments-list' : ''
  }, [_vm._v(_vm._s(_vm.showPreviousPayments ? 'Hide Previous Payments' : 'View Previous Payments') + "\n          "), _c('img', {
    staticClass: "mr1",
    attrs: {
      "src": _vm.showPreviousPayments ? '../../../../../static/appicons/cross-red.svg' : '../../../../../static/appicons/down-arrow.svg',
      "alt": "",
      "width": "12"
    }
  })])])], 1), _vm._v(" "), (this.showPreviousPayments) ? _c('div', {
    staticClass: "ph3 pv2 payments-list-background mh3"
  }, [_vm._l((this.user.invoice_information.all_invoices.slice(0, 3)), function(invoice, index) {
    return _c('div', {
      key: index,
      staticClass: "payment-methods"
    }, [_c('a', {
      staticClass: "flex justify-between mv2 no-underline items-center cell pointer black payments-list",
      attrs: {
        "href": invoice.hosted_invoice_url,
        "target": "_blank"
      }
    }, [_c('label', {
      staticClass: "f5 pointer db flex"
    }, [_vm._v(_vm._s(_vm.getInvoiceDate(invoice))), _c('span', {
      staticClass: "silver-element ml1"
    }, [_vm._v(" " + _vm._s(invoice.status.charAt(0).toUpperCase() + invoice.status.slice(1)))]), _c('span', {
      staticClass: "color-theme no-underline flex ml1"
    }, [_c('svg', {
      attrs: {
        "height": "17px",
        "viewBox": "0 0 48 48",
        "width": "17px",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('g', {
      attrs: {
        "id": "surface8346467"
      }
    }, [_c('path', {
      staticStyle: {
        "stroke": "none",
        "fill-rule": "nonzero",
        "fill": "rgb(95.294118%,6.27451%,23.921569%)",
        "fill-opacity": "1"
      },
      attrs: {
        "d": "M 41.46875 4.988281 C 41.417969 4.988281 41.363281 4.992188 41.308594 5 L 27.5 5 C 26.960938 4.992188 26.457031 5.277344 26.183594 5.742188 C 25.910156 6.210938 25.910156 6.789062 26.183594 7.257812 C 26.457031 7.722656 26.960938 8.007812 27.5 8 L 37.878906 8 L 22.4375 23.441406 C 22.046875 23.816406 21.890625 24.375 22.027344 24.898438 C 22.164062 25.425781 22.574219 25.835938 23.101562 25.972656 C 23.625 26.109375 24.183594 25.953125 24.558594 25.5625 L 40 10.121094 L 40 20.5 C 39.992188 21.039062 40.277344 21.542969 40.742188 21.816406 C 41.210938 22.089844 41.789062 22.089844 42.257812 21.816406 C 42.722656 21.542969 43.007812 21.039062 43 20.5 L 43 6.691406 C 43.058594 6.253906 42.925781 5.8125 42.628906 5.484375 C 42.335938 5.15625 41.910156 4.972656 41.472656 4.988281 Z M 12.5 8 C 8.375 8 5 11.375 5 15.5 L 5 35.5 C 5 39.625 8.375 43 12.5 43 L 32.5 43 C 36.625 43 40 39.625 40 35.5 L 40 25.5 C 40.007812 24.960938 39.722656 24.457031 39.257812 24.183594 C 38.789062 23.910156 38.210938 23.910156 37.742188 24.183594 C 37.277344 24.457031 36.992188 24.960938 37 25.5 L 37 35.5 C 37 38.003906 35.003906 40 32.5 40 L 12.5 40 C 9.996094 40 8 38.003906 8 35.5 L 8 15.5 C 8 12.996094 9.996094 11 12.5 11 L 22.5 11 C 23.039062 11.007812 23.542969 10.722656 23.816406 10.257812 C 24.089844 9.789062 24.089844 9.210938 23.816406 8.742188 C 23.542969 8.277344 23.039062 7.992188 22.5 8 Z M 12.5 8 "
      }
    })])])])]), _vm._v(" "), _c('span', {
      staticClass: "pointer"
    }, [_vm._v(_vm._s(_vm.getInvoiceAmount(invoice)))])]), _vm._v(" "), _c('hr', {
      staticClass: "line"
    })])
  }), _vm._v(" "), _c('router-link', {
    staticClass: "flex justify-center no-underline cell payments-list mt2 items-center color-theme payments-list",
    attrs: {
      "to": "/account/invoices"
    }
  }, [_vm._v("\n        View More\n      ")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pa3 mt2 flex items-center cell"
  }, [_c('span', {
    staticClass: "silver-element"
  }, [_vm._v(_vm._s(_vm.$t('billingsettings.paymentmethods', {
    paymentmethods: 'Payment Methods'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "mh3"
  }, [(_vm.user.credit_card_brand && _vm.user.credit_card_last4) ? _c('div', [_c('div', {
    staticClass: "pt3 pr3 mb3 pb0-ns flex justify-between items-center cell"
  }, [_c('label', {
    staticClass: "f5 db card-info"
  }, [_c('img', {
    staticClass: "mb40 logo-card",
    attrs: {
      "src": _vm.getCardBrandLogo(_vm.user.credit_card_brand),
      "alt": "Credit Card Logo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column"
  }, [_c('div', {
    staticClass: "flex flex-row responsive-column mb1"
  }, [_c('p', {
    staticClass: "ml2 f5"
  }, [_vm._v(" " + _vm._s(_vm.user.credit_card_brand))]), _vm._v(" "), _c('span', {
    staticClass: "ml2 f5"
  }, [_vm._v("(" + _vm._s(_vm.$t('billingsettings.endswith', {
    endswith: 'ends with'
  })) + " *" + _vm._s(_vm.user.credit_card_last4) + ")")])])])]), _vm._v(" "), _c('span', {
    staticClass: "default-card"
  }, [_vm._v(_vm._s(_vm.$t('billingsettings.selectedas', {
    selectedas: 'Default'
  })))])]), _vm._v(" "), (_vm.showCreditCardModal) ? _c('UpdatePaymentMethodModal', {
    ref: "cardForm",
    attrs: {
      "can-add-payment-method": _vm.canAddPaymentMethod,
      "reset-state": _vm.resetState,
      "show-credit-card-modal": _vm.showCreditCardModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user.credit_card_brand && _vm.user.credit_card_last4 && !_vm.showCreditCardModal) ? _c('div', {
    staticClass: "dib-ns mb4 btn-add-parent"
  }, [_c('ak-button', {
    staticClass: "btn-add inter",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.user.payment_method !== 'CREDIT_DEBIT_CARD' ? _vm.openIntercomChat : _vm.showCreditCardModal = true
      }
    }
  }, [_vm._v("\n            Update Payment\n            Method\n          ")])], 1) : _vm._e()], 1) : _c('div', [_vm._v("\n        If you'd like to update your payment method, please email\n        "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com",
      "rel": "noopener noreferrer",
      "target": "_blank"
    }
  }, [_vm._v("billing@getakko.com")]), _vm._v(".\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22d0161a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account-settings/screens/billing/Billing.vue
// module id = 1197
// module chunks = 0